import * as React from 'react';
import './edit-state-modal.scss';
import { Modal } from 'components/modal/modal';
import { Dropdown } from 'components/dropdown/dropdown';
import { Button, buttonType } from 'components/button/button';
import { Enum } from 'core/domain/commons/common';
import { Order } from 'core/domain/order/order';
import { editOrderState } from 'core/repositories/orders';

interface Props {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    item: Order;
    orderStates: Enum[];
    onSuccess: () => void;
}

export const OrderStateEditModal: React.FC<Props> = ({ isOpen, setIsOpen, item, orderStates, onSuccess }) => {
    const [buttonLoading, setButtonLoading] = React.useState(false);
    const [selectedState, setSelectedState] = React.useState<Enum | undefined>(undefined);

    // با باز شدن مودال، وضعیت فعلی سفارش پیش‌فرض انتخاب می‌شود.
    React.useEffect(() => {
        if (!orderStates?.length || !item?.state) return;
        setSelectedState(orderStates.find((s) => s.id === item.state.id) ?? orderStates[0]);
    }, [orderStates, item]);

    const isUnchanged = !selectedState || selectedState.id === item?.state?.id;

    return (
        <Modal className="order-state-edit-modal" isOpen={isOpen} setIsOpen={setIsOpen}>
            <h3>تغییر وضعیت سفارش</h3>
            <div className="row summary">
                <span className="label">شناسه سفارش</span>
                <span className="en value">{item?.trackingCode}</span>
            </div>
            <div className="row summary">
                <span className="label">وضعیت فعلی</span>
                <span className="value">{item?.state?.title}</span>
            </div>
            <div className="row">
                <label>وضعیت جدید</label>
                {orderStates?.length > 0 && selectedState && (
                    <Dropdown
                        items={orderStates}
                        onChangeHandle={(value) => setSelectedState(orderStates.find((s) => s.id === value))}
                        selectedOption={selectedState}
                    />
                )}
            </div>
            <div className="buttons">
                <Button
                    loading={buttonLoading}
                    disabled={isUnchanged}
                    type={buttonType.info}
                    text="اعمال تغییرات"
                    onClick={async () => {
                        if (!item?.trackingCode || !selectedState) return;
                        await editOrderState(
                            setButtonLoading,
                            { trackingCode: item.trackingCode, state: selectedState.id },
                            () => {
                                setIsOpen(false);
                                onSuccess();
                            },
                        );
                    }}
                />
                <Button type={buttonType.outlined} text="بازگشت" onClick={() => setIsOpen(false)} />
            </div>
        </Modal>
    );
};
